var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<p>Please confirm your desire to delete the {{$ctrl.request.network}} ending in {{$ctrl.request.lastFour}}?</p>";
var id1="consumer-payment-method-delete-confirmation.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;